/**
 * What a rejected call can be shown as. A caught value is `unknown`: the api
 * throws `Error`, but a network stack, a library or a bare `throw` can hand
 * over anything, and a toast needs a sentence either way.
 */

/** The message the failure carries, or `fallback` when it carries none. */
export function getFailureMessage(error: unknown, fallback: string): string {
    return error instanceof Error && error.message ? error.message : fallback;
}

/** The message the failure carries, or its own string form — for a toast that prefixes it. */
export function getFailureText(error: unknown): string {
    return error instanceof Error ? error.message : String(error);
}

/** The failure as an `Error`, for a snapshot field that is typed as one. */
export function toError(error: unknown): Error {
    return error instanceof Error ? error : new Error(String(error));
}
